<div
  class="limit-bar-common limit-bar-container"
  [class.bar-loading]="isLoading()"
  [class.primary-colors]="!isLoading() && color() === 'primary'"
  [class.warn-colors]="!isLoading() && color() === 'warn'"
  [class.error-colors]="!isLoading() && color() === 'error'"
  [class.success-colors]="!isLoading() && color() === 'success'"
>
  <div
    class="limit-bar-common limit-bar-progress"
    [class.animate-on-enter]="animateOnEnter()"
    [style.--glxy-progress]="progress() + '%'"
  ></div>
</div>
